export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/logo-seed.png" alt="Seed Motors" className={`${className} object-contain`} />
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="w-9 h-9 group-hover:rotate-12 transition-transform duration-300" />
    <span className="font-display text-xl tracking-tight font-extrabold text-white">
      Seed <span className="text-emerald-400 font-semibold">Motors</span>
    </span>
  </span>
);
